import { countryData } from '@/constants/country-data'

const getSupportedCountriesByTamara = () => {
  return countryData.map(({ countryCode }) => countryCode)
}

const findIndexOfCountry = (countries, countryCode) =>
  countries.indexOf(countryCode)

const sortCountryOptions = (supportedCountry) => (optionA, optionB) => {
  const foundIndexA = findIndexOfCountry(supportedCountry, optionA.isoCode)
  const foundIndexB = findIndexOfCountry(supportedCountry, optionB.isoCode)

  if (foundIndexA !== -1 && foundIndexB !== -1) {
    return foundIndexA - foundIndexB
  }

  if (foundIndexA !== -1 || foundIndexB !== -1) {
    return foundIndexB - foundIndexA
  }

  return optionA.name.localeCompare(optionB.name)
}

const buildCountryCallingCodeOptions = (countryNames, countryCallingCodes) => {
  const supportedCountries = getSupportedCountriesByTamara()

  return Object.entries(countryNames)
    .map(([iso, name]) => {
      const callingCode = countryCallingCodes?.[iso] || ''
      const label = `+${callingCode}`

      return {
        key: iso,
        isoCode: iso,
        label: label,
        callingCode: callingCode,
        name: name,
        value: label,
      }
    })
    .sort(sortCountryOptions(supportedCountries))
}

const findCountryDataByCountryCallingCode = (countryCallingCodes) => {
  return countryData.find(
    ({ telephoneCode }) => telephoneCode === countryCallingCodes
  )
}

const checkPhoneNumber = (countryCallingCodes, phoneNumber) => {
  if (!phoneNumber) {
    return 'error_phone_number_empty_field'
  }

  const isNum = /^\d+$/.test(phoneNumber)

  if (!isNum) {
    return 'error_phone_number_includes_non_numeric_characters'
  }

  phoneNumber = phoneNumber.replace(/^0/, '')

  const selectedCountryData = findCountryDataByCountryCallingCode(
    countryCallingCodes
  )

  if (phoneNumber.length < selectedCountryData.numberMinLength) {
    return 'error_phone_number_too_short'
  }
  if (phoneNumber.length > selectedCountryData.numberMaxLength) {
    return 'error_phone_number_too_long'
  }
  const firstNumber = Number(phoneNumber.substring(0, 1))

  if (!selectedCountryData.numberStartsWith.includes(firstNumber)) {
    return 'error_phone_number_invalid'
  }

  return null
}

export {
  buildCountryCallingCodeOptions,
  checkPhoneNumber,
  findCountryDataByCountryCallingCode,
}
